module.exports = __webpack_public_path__ + "img/rating.9d148e32.svg";